import * as stylex from "@stylexjs/stylex";
import { Upload, X } from "lucide-react";
import { copy } from "@/copy";
import "@/theme/tokens.stylex";
import { colors, radii, space } from "@/theme/tokens.stylex";
import { Button } from "@/ui/Button";
import { QrCode } from "@/ui/QrCode";
export type QrShown = {
  url?: string;
};
type AddFromPhoneProps = {
  qr: QrShown;
  onChooseFiles: () => void;
};
type PanelProps = AddFromPhoneProps & {
  onDone: () => void;
};
const words = copy.photos.qr;
const PANEL_CODE_PX = 125;
export function AddFromPhonePanel({
  qr,
  onChooseFiles,
  onDone
}: PanelProps) {
  return (
    // biome-ignore lint/a11y/useSemanticElements: a fieldset can't lay out its content as a flex column
    <div role="group" aria-label={words.name} className="x78zum5 xdt5ytf x1hu4l6k x1vvitgl x9f619 x1fv5t7x x5r8ks9">
      <div className="x78zum5 x1a02dak x6s0dn4 xddi9bj">
        <QrCode value={qr.url} label={words.code} size={PANEL_CODE_PX} />
        <div className="x78zum5 xdt5ytf x17d4w8g x1iyjqo2 x1r8uery x5w4yej">
          <span className="xosj86m xfbjfs5 x1yrajzq">{words.title}</span>
          <span className="x1jvydc1 x15i68ds xfrs9s4 x1fzhlzt">{words.body}</span>
        </div>
      </div>
      <div className="x78zum5 x1a02dak x152posx">
        <Button variant="secondary" icon={Upload} onClick={onChooseFiles}>
          {words.chooseFiles}
        </Button>
        <Button variant="ghost" icon={X} onClick={onDone}>
          {words.done}
        </Button>
      </div>
    </div>
  );
}
export function AddFromPhoneCard({
  qr,
  onChooseFiles
}: AddFromPhoneProps) {
  return (
    // biome-ignore lint/a11y/useSemanticElements: a fieldset can't lay out its content as a wrapping flex row
    <div role="group" aria-label={words.name} className="x78zum5 x1a02dak x6s0dn4 xl56j7k x1ur044a x27kpxv x18ppelm x9f619 xwe7p7i xh540kj xdpxx8g">
      <QrCode value={qr.url} label={words.code} />
      <div className="x78zum5 xdt5ytf x1iyjqo2 x1r8uery x152posx x12rczxh">
        <span className="xfbjfs5 x1yrajzq xwsyq91">{words.title}</span>
        <span className="x1jvydc1 x15i68ds xfrs9s4 x1fzhlzt">{words.body}</span>
        <div className="x78zum5 x1gslohp x1rm44br">
          <Button variant="ghost" icon={Upload} onClick={onChooseFiles}>
            {words.chooseFiles}
          </Button>
        </div>
      </div>
    </div>
  );
}